import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { baseUrl } from "../../../baseUrl";

const EditPackage = () => {
  const [packageName, setPackageName] = useState("");
  const [examName, setExamName] = useState("");
  const [payment, setPayment] = useState("");
  const [amount, setAmount] = useState("");
  const [description,setDescription]=useState("")
  const [active,setActive]=useState(true)
  const [message,setMessage]=useState(false)
  const [file,setFile]=useState(null)
  const [fileName,setFileName]=useState("")
  const [filePath,setFilePath]=useState("")
  const params=useParams()
  const data={packageName,examName,payment,amount,active,fileName,filePath}

  const getPackage=()=>{
    axios.get(`${baseUrl}/package/get/?id=${params.id}`)
    .then(res=>{
        setPackageName(res.data.packageName)
        setExamName(res.data.examName)
        setPayment(res.data.paymentType)
        setAmount(res.data.amount)
        setDescription(res.data.description)
        setActive(res.data.active)
        setFileName(res.data.fileName)
        setFilePath(res.data.path)

    })
    .catch(err=>console.log(err))
  }
  useEffect(()=>{
    getPackage()
  },[]
)
  const handleSubmit=(e)=>{
    const formData=new FormData()
    formData.append('data',JSON.stringify(data))
    formData.append('id',params.id)
    if(file){
        for(var i=0;i<file.length;i++){

            formData.append('file',file[i])
        }
    }

    axios.post(`${baseUrl}/index/package/update`,formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    .then(res=>{
        if(res.data==="success"){
          getPackage()
            setMessage("Package Updated")
        }
        if(res.data==="failed"){
            setMessage("Something went wrong")
        }
    })
    .catch(err=>console.log(err))
}
  return (
    <div className="container">
      <h2 className="text-center mt-5">Edit Package</h2>
      <Link to='/admin/exams/packages'>back</Link>
      <div className="row mt-3">
        <div className="col-6">
          <label htmlFor="packageName" className="form-label">
            Package Name
          </label>
          <input
            type="text"
            className="form-control"
            id="packageName"
            placeholder="Enter Package Name"
            onChange={(e) => setPackageName(e.target.value)}
            value={packageName}
          />
        </div>
        <div className="col-6">
          <label htmlFor="examName" className="form-label">
            Exam Name
          </label>
          <input
            type="text"
            className="form-control"
            id="examName"
            placeholder="Exam name"
            onChange={(e) => setExamName(e.target.value)}
            value={examName}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-6">
          <label htmlFor="paymentType" className="form-label">
            Payment Type
          </label>
          <input
            type="text"
            className="form-control"
            id="paymentType"
            placeholder="Payment Type"
            onChange={(e) => setPayment(e.target.value)}
            value={payment}
          />
        </div>
        <div className="col-6">
          <label htmlFor="amount" className="form-label">
            Amount
          </label>
          <input
            type="number"
            className="form-control"
            id="amount"
            placeholder="amount"
            onChange={(e) => setAmount(e.target.value)}
            value={amount}
          />
        </div>
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea value={description} className="form-control" id="description"></textarea>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="image" className="form-label">
              Image
            </label>
            <input onChange={(e)=>setFile(e.target.files)} type="file" className="form-control" />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="image" className="form-label px-2">
              Active
            </label>
            <input value={active} checked={active} onChange={()=>setActive(!active)} className="ml-2" type="checkbox" />
          </div>
        </div>
        {
                message&&
                <div
              className="alert alert-warning alert-dismissible fade show mt-3"
              role="alert"
            >
                {message}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
                onClick={()=>setMessage(false)}
              ></button>
            </div>
            }
        <button onClick={handleSubmit} className="btn btn-primary" style={{ width: "100px" }}>
          Update
        </button>
      </div>
    </div>
  );
};

export default EditPackage;
